export default "__VITE_ASSET__T70O4u4B__";